import React, { createContext, useContext, useMemo, useState } from "react";

const BreadcrumbContext = createContext(null);

export function BreadcrumbProvider({ children }) {
  const [labelOverride, setLabelOverride] = useState(null);
  const value = useMemo(
    () => ({ labelOverride, setLabelOverride }),
    [labelOverride]
  );
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}

export function useBreadcrumbContext() {
  return useContext(BreadcrumbContext);
}

/** Sayfa başlığını breadcrumb son segmenti olarak geçersiz kılar */
export function useBreadcrumbLabel(label) {
  const ctx = useContext(BreadcrumbContext);

  React.useEffect(() => {
    if (!ctx || !label) return undefined;
    ctx.setLabelOverride(label);
    return () => ctx.setLabelOverride(null);
  }, [label, ctx]);
}
